import * as React from 'react';
import styled from '@emotion/styled';
import ToggleIcon from '../icons/ToggleIcon';

const Card = styled.div`
  background: #fff;
  padding: 5px 2%;
  box-shadow: -2px 3px 3px -1px rgba(0, 0, 0, 0.05);
`;
const CardHeader = styled.div`
  position: relative;
  line-height: 4rem;
  border-bottom: ${(s: StyleProps) => (s.showCard ? '1px solid #ddd' : 'none')};
`;
const CardTitle = styled.h2`
  display: inline-block;
  margin: 0 2rem 0 0;
  padding: 0;
  line-height: 4rem;
  font-size: 18px;
  font-family: 'open sans', sans-serif;
  font-weight: 600;
  cursor: pointer;
  color: ${(s: StylePropsTitle) => (s.shown ? '#0076CE' : '#809DC4')};
  border-bottom: ${(s: StylePropsTitle) => (s.shown ? '4px solid #007db8' : '')};
  &:hover {
    color: #007db8;
    border-bottom: 4px solid #007db8;
  }
`;

const IconWrapper = styled.div`
  margin-right: 1rem;
  display: inline-block;
  float: right;
  cursor: pointer;
  line-height: 0;
  padding: 10px 0;
  transform: ${(s: StyleProps) => (s.showCard ? 'rotate(0deg)' : 'rotate(180deg)')};
`;

interface Props {
  virtualSummaryTitle: string;
  physicalSummaryTitle: string;
  graphSummaryTitle: string;
  virtualSummary: React.ReactNode;
  physicalSummary: React.ReactNode;
  graphSummary: React.ReactNode;
}
interface StyleProps {
  showCard: boolean;
}
interface StylePropsTitle {
  shown: boolean;
}
interface State {
  showCard: boolean;
  virtual: boolean;
  physical: boolean;
  graph: boolean;
}

class SummariesCard extends React.Component<Props, any> {
  state = {
    showCard: true,
    virtual: true,
    physical: false,
    graph: false
  } as State;

  toggle = () => {
    this.setState((prevState: State) => ({
      showCard: !prevState.showCard
    }));
  };
  switchTab = (tab: string) => {
    switch (tab) {
      case this.props.virtualSummaryTitle:
        this.setState({ virtual: true, physical: false, graph: false });
        break;
      case this.props.physicalSummaryTitle:
        this.setState({ virtual: false, physical: true, graph: false });
        break;
      case this.props.graphSummaryTitle:
        this.setState({ virtual: false, physical: false, graph: true });
        break;
      default:
        this.setState({ virtual: true, physical: false, graph: false });
        break;
    }
  };
  selectTab = () => {
    if (this.state.virtual) {
      return this.props.virtualSummary;
    } else if (this.state.physical) {
      return this.props.physicalSummary;
    } else {
      return this.props.graphSummary;
    }
  };

  render() {
    return (
      <Card>
        <CardHeader showCard={this.state.showCard}>
          <CardTitle
            shown={this.state.virtual}
            onClick={() => this.switchTab(this.props.virtualSummaryTitle)}
          >
            {this.props.virtualSummaryTitle}
          </CardTitle>
          <CardTitle
            shown={this.state.physical}
            onClick={() => this.switchTab(this.props.physicalSummaryTitle)}
          >
            {this.props.physicalSummaryTitle}
          </CardTitle>
          <CardTitle
              shown={this.state.graph}
              onClick={() => this.switchTab(this.props.graphSummaryTitle)}
            >
              {this.props.graphSummaryTitle}
          </CardTitle>
          <IconWrapper showCard={this.state.showCard} onClick={this.toggle}>
            <ToggleIcon />
          </IconWrapper>
        </CardHeader>
        {this.state.showCard ? this.selectTab() : ''}
      </Card>
    );
  }
}
export default SummariesCard;
